<template>
    <button
        type="button"
        class="btn"
        :class="buttonClass"
        @click="getSocialUrl">
        <i :class="iconClass"></i>
        <span v-html="buttonText"></span>
    </button>

</template>

<script>
    import {socialConnect} from 'api/services'

    export default {
        name: 'social-button',

        props: ['buttonType', 'buttonClass', 'iconClass', 'buttonText'],

        data() {
            return {}
        },

        methods: {
            getSocialUrl() {
                socialConnect(this.buttonType).then(() => {
                    /* window.location.href = response.login_url */
                }).catch((error) => {
                    console.log(error)
                })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Authentication/Social/SocialButton/SocialButton.vue